import { render, staticRenderFns } from "./itemedit.vue?vue&type=template&id=6e18fd44&scoped=true"
import script from "./itemedit.vue?vue&type=script&lang=js"
export * from "./itemedit.vue?vue&type=script&lang=js"
import style0 from "./itemedit.vue?vue&type=style&index=0&id=6e18fd44&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18fd44",
  null
  
)

export default component.exports